import { useQuery } from "@tanstack/react-query";

import {
  type ClientListSortColumn,
  type ClientStatus,
  getClients,
  type SortOrder,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { CLIENTS_QUERY_KEYS } from "./queryKeys";

export interface UseClientsQueryParams {
  offset?: number;
  limit?: number;
  searchQuery?: string | null;
  partnerIDs?: string[];
  sortBy?: ClientListSortColumn;
  sortOrder?: SortOrder;
  statusFilter?: ClientStatus[] | null;
}

export function useClientsQuery(params?: UseClientsQueryParams) {
  const {
    offset,
    limit,
    searchQuery,
    partnerIDs,
    sortBy,
    sortOrder,
    statusFilter,
  } = params ?? {};

  return useQuery({
    queryKey: CLIENTS_QUERY_KEYS.list(
      offset,
      limit,
      searchQuery,
      partnerIDs,
      sortBy,
      sortOrder,
    ),
    queryFn: processResponse(() =>
      getClients(
        limit,
        offset,
        searchQuery,
        partnerIDs,
        sortBy,
        sortOrder,
        statusFilter,
      ),
    ),
  });
}
